import React, { useContext, useState } from "react";
import { Dropdown, Button, Card, Input, Row, Col, Divider } from "antd";
import { IoIosArrowUp } from "react-icons/io";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
import mainContext from "../context/MainContext/mainContext";

const TotalProductionCost = ({ salesOrderData, handleFormChange }) => {
  const { justView } = useContext(mainContext);
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  console.log("salesOrderData: ", salesOrderData);

  const getTotalCharges = () => {
    if (
      !salesOrderData?.inventories?.length &&
      !salesOrderData?.suffixInventories?.length
    )
      return { printingCharge: 0, mountingCharge: 0, innovationCharge: 0, prnCharge: 0 };

    const invCharges = salesOrderData.inventories?.reduce(
      (acc, inv) => {
        acc.printingCharge += Number(inv.printingCharge) || 0;
        acc.mountingCharge += Number(inv.mountingCharge) || 0;
        acc.innovationCharge += Number(inv.innovationRate) || 0;
        return acc;
      },
      { printingCharge: 0, mountingCharge: 0, innovationCharge: 0, prnCharge: 0 }
    );

    // Calculate total Printing Suffix Code charges from all items in suffixInventories
    if (salesOrderData?.suffixInventories?.length) {
      const prnCharges = salesOrderData.suffixInventories
        .filter((item) => item.suffixCode === "Printing")
        .reduce((total, item) => total + (Number(item.specialRate) || 0), 0);
      invCharges.prnCharge = prnCharges;
    }

    return invCharges;
  };

  const { printingCharge, mountingCharge, innovationCharge, prnCharge } = getTotalCharges();
  const totalProductionCost = printingCharge + mountingCharge + innovationCharge + prnCharge;

  // Dropdown content
  const dropdownContent = (
    <Card style={{ border: "1px solid lightgrey" }}>
      <Row>
        <Col span={12}>Printing Charge</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            readOnly={justView}
            value={formatIndianNumber(printingCharge)}
            // onChange={(e) => handleFormChange("printingCharge", e.target.value)}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col span={12}>Mounting Charge</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            readOnly={justView}
            value={formatIndianNumber(mountingCharge)}
            // onChange={(e) => handleFormChange("mountingCharge", e.target.value)}
          />
        </Col>
      </Row>
      {innovationCharge > 0 && (
        <Row style={{ marginTop: "10px" }}>
          <Col span={12}>Innovation Charge</Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Input
              readOnly={justView}
              value={formatIndianNumber(innovationCharge)}
            />
          </Col>
        </Row>
      )}
      {prnCharge > 0 && (
        <Row style={{ marginTop: "10px" }}>
          <Col span={12}>Printing Suffix Charge</Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Input
              readOnly={justView}
              value={formatIndianNumber(prnCharge)}
              // onChange={(e) => handleFormChange("prnCharge", e.target.value)}
            />
          </Col>
        </Row>
      )}
      <Divider />
      <Row style={{ fontWeight: "bold", marginTop: "10px" }}>
        <Col span={12}>Total Production Cost</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          {formatIndianNumber(totalProductionCost)}
          {/* Format the total with commas */}
        </Col>
      </Row>
    </Card>
  );

  return (
    <Dropdown
      overlay={dropdownContent}
      trigger={["click"]}
      visible={visible}
      onVisibleChange={handleVisibleChange}
      placement="bottomLeft"
    >
      <Button className="totalProductionCost-btn">
        Total Production Cost:
        <span style={{ marginLeft: "4rem" }}>
          {formatIndianNumber(totalProductionCost)}
          <IoIosArrowUp style={{ marginLeft: "1rem" }} />
        </span>
      </Button>
    </Dropdown>
  );
};

export default TotalProductionCost;
